@defer (when render()) {
  <app-auth-guard>
    <app-center-guard>
      <router-outlet />
    </app-center-guard>
  </app-auth-guard>
}
